<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="iphone-mobile"
    data-name="Iphone, Mobile, Phone"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <path id="Path_8453" data-name="Path 8453" d="M0,0H28V28H0Z" fill="none" />
    <path
      id="Path_8454"
      data-name="Path 8454"
      d="M17.667,24H8.333A2.333,2.333,0,0,1,6,21.667V5.333A2.333,2.333,0,0,1,8.333,3h9.333A2.333,2.333,0,0,1,20,5.333V21.667A2.333,2.333,0,0,1,17.667,24Z"
      transform="translate(1 0.5)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8455"
      data-name="Path 8455"
      d="M12.207,19.125a.292.292,0,1,0,.293.292.29.29,0,0,0-.293-.292M10.75,6h2.917"
      transform="translate(1.792 1)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>
